import {
  GET_PROVIDERS,
  SET_ACH_ACCOUNTS,
  PENDING_PROVIDERS,
  GET_PROVIDER_BY_ID,
  CLEAR_PROVIDER_LIST,
  GET_PROVIDERS_MODULES,
  CLEAR_PENDING_PROVIDERS,
} from "../constants/constants";

const initialSessionState = { providers: [], provider: {}, pending: [], achbanks: [], modules: [] };

export default (state = initialSessionState, action) => {
  switch (action.type) {
    case GET_PROVIDERS:
      return {
        ...state,
        providers: [ ...action.providers.content ],
        totalElements: action.providers.totalElements
      };
    case GET_PROVIDER_BY_ID:
      return {
        ...state,
        provider: { ...action.provider }
      };
    case GET_PROVIDERS_MODULES:
      return {
        ...state,
        modules: [...action.modules]
      };
    case PENDING_PROVIDERS:
      return {
        ...state,
        pending: [...action.providers.content],
        pendingElements: action.providers.totalElements
      };
    case SET_ACH_ACCOUNTS:
      return {
        ...state,
        achbanks: [...action.banks]
      };
    case CLEAR_PROVIDER_LIST:
      return {
        ...state,
        providers: [],
        totalElements: 0
      };
    case CLEAR_PENDING_PROVIDERS:
      return {
        ...state,
        pending: [],
        pendingElements: 0
      };
    default:
      return state;
  }
};

export const getModules = state => state.providerReducer.modules;
export const getAchBanks = state => state.providerReducer.achbanks;
export const getProviders = state => state.providerReducer.providers;
export const getOneProvider = state => state.providerReducer.provider;
export const getAllProviders = state => state.providerReducer.providers;
export const getProvidersByClient = state => state.providerReducer.providers;
export const getTotalElements = state => state.providerReducer.totalElements;
export const getPendingProviders = state => state.providerReducer.pending;
export const getPendingProvidersBSC = state => state.providerReducer.pending;
export const getTotalPendingProviders = state => state.providerReducer.pendingElements;
